import { DeleteOutlined } from "@ant-design/icons";
import { Button, ButtonProps, message, Popconfirm } from "antd";
import { useDeleteAccountingStatementMutation } from "redux/api/reconciliationsApiSlice";

export const DeleteAccountingStatementButton = ({ uuid, ...buttonProps }: { uuid: string } & ButtonProps) => {
  const [deleteAccountingStatement, { isLoading }] = useDeleteAccountingStatementMutation();

  return (
    <Popconfirm
      title={"Sei sicuro di voler eliminare questo estratto conto?"}
      disabled={buttonProps.disabled}
      okText={"Elimina"}
      okType={"danger"}
      onConfirm={() => {
        deleteAccountingStatement(uuid).unwrap().then((result) => {
          message.success("Estratto conto eliminato");
        });
      }}>
      <Button
        title={"Elimina estratto conto"}
        type={"text"}
        danger={true}
        icon={<DeleteOutlined />}
        loading={isLoading}
        disabled={isLoading}
        {...buttonProps} />
    </Popconfirm>
  );
};